import { nothing } from 'lit';
import { AsyncDirective } from 'lit/async-directive.js';
import { directive, PartType } from 'lit/directive.js';
import { isNil, isString } from '../../utils/unit';
import { listen, redispatchEvent } from '../events';
export class ForwardEventDirective extends AsyncDirective {
    constructor(partInfo) {
        super(partInfo);
        if (partInfo.type !== PartType.ELEMENT) {
            throw new Error('The `forwardEvent` directive must be used on an element tag.');
        }
    }
    render(type) {
        return nothing;
    }
    update(part, [type]) {
        var _a, _b;
        if (this._element !== part.element ||
            this._type !== type ||
            this._host !== ((_a = part.options) === null || _a === void 0 ? void 0 : _a.host)) {
            this._element = part.element;
            this._type = type;
            this._host = (_b = part.options) === null || _b === void 0 ? void 0 : _b.host;
            this._removeEventListener();
            this._addEventListener();
        }
        return nothing;
    }
    _addEventListener() {
        if (isNil(this._element) || isNil(this._host) || !isString(this._type)) {
            return;
        }
        this._dispose = listen(this._element, this._type, (e) => {
            redispatchEvent(this._host, e);
        });
    }
    _removeEventListener() {
        var _a;
        (_a = this._dispose) === null || _a === void 0 ? void 0 : _a.call(this);
        this._dispose = undefined;
    }
    reconnected() {
        this._addEventListener();
    }
    disconnected() {
        this._removeEventListener();
    }
}
/**
 * @param type - The name of the event to listen to and forward.
 */
export const forwardEvent = directive(ForwardEventDirective);
